import type {
  FrequencyTab,
} from "./types";

export const FREQUENCY_BUDGET_APPROVAL = "BUDGET_APPROVAL";
export const FREQUENCY_REAL_TIME = "REAL_TIME";
export const FREQUENCY_MONTHLY = "MONTHLY";
export const FREQUENCY_QUARTERLY = "QUARTERLY";
export const FREQUENCY_YEARLY = "YEARLY";
export const FREQUENCY_ADHOC = "ADHOC";
export const JOB_ID = "jobId";
export const RUN_TYPE = "runType";
export const FREQUENCY = "frequency";
export const STATUS = "status";
export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";

export const PLANNED = "PLAN";
export const ACTUALS = "ACTUAL";

export const plannedTab = [
  {
    label: "Planned",
    value: PLANNED,
  }
];

export const actualTab = [
  {
    label: "Actuals",
    value: ACTUALS,
  },
];

export const searchType = [
  {
    label: "Job ID",
    value: JOB_ID,
  },
  {
    label: "Run Type",
    value: RUN_TYPE,
  },
  {
    label: "Status",
    value: STATUS,
  },
];

export const plannedFrequency = [
  {
    label: "Real Time",
    value: FREQUENCY_BUDGET_APPROVAL,
    runType: 'Real Time'
  },
];

export const frequencyTabs: FrequencyTab[] = [
  {
    label: "Real Time",
    value: FREQUENCY_REAL_TIME,
    runType: 'Real Time'
  },
  {
    label: "Monthly",
    value: FREQUENCY_MONTHLY,
    runType: 'Periodic'
  },
  {
    label: "Quarterly",
    value: FREQUENCY_QUARTERLY,
    runType: 'Periodic'
  },
  {
    label: "Yearly",
    value: FREQUENCY_YEARLY,
    runType: 'Periodic'
  },
  {
    label: "Adhoc",
    value: FREQUENCY_ADHOC,
    runType: 'Adhoc'
  },
];